import { colorSystem, Tooltip } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import { StarIcon } from 'lucide-react';
import type { JSX } from 'react';

import { PreferredTagEnum, preferredTagTooltipTranslations } from './PreferredTag';

export const PreferredIpnTag = ({
    showTooltip = true,
    iconStyle,
}: {
    showTooltip?: boolean;
    /** Places the star among its neighbors; its size and color are fixed. */
    iconStyle?: Pick<React.CSSProperties, 'alignSelf' | 'margin'>;
}): JSX.Element => {
    return (
        <Tooltip title={showTooltip ? transEnum(PreferredTagEnum.Ipn, preferredTagTooltipTranslations) : ''}>
            <StarIcon
                size={16}
                color={colorSystem.primary[7]}
                style={{ alignSelf: iconStyle?.alignSelf, margin: iconStyle?.margin }}
                aria-hidden
                fill={colorSystem.primary[7]}
            />
        </Tooltip>
    );
};
